import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import { LoadingBlock } from "@/components/AsyncState";

const CirclePage = lazy(() => import("@/pages/CirclePage"));

function CircleFallback() {
  return (
    <div className="px-4 pt-20">
      <LoadingBlock label="Circle…" />
    </div>
  );
}

export const Route = createFileRoute("/circle")({
  head: () => ({
    meta: [
      { title: "Circle · Pulse" },
      { name: "description", content: "Plan nights with your Circle." },
    ],
  }),
  component: () => (
    <Suspense fallback={<CircleFallback />}>
      <CirclePage />
    </Suspense>
  ),
});
